import { POSTHOG_FEATURE_FLAGS, usePostHogFeatureFlag } from '../usePostHogFeatureFlag'
import { usePermissions } from '../usePermissions'

/**
 * Whether the viewer can open the Roles list and role pages: the `ad_roles_view` flag is on and
 * they can view roles on at least one domain. An unresolved flag reads as `false`, so callers that
 * redirect on `false` must wait for `useFeatureFlagsReady()` first.
 */
export function useRolesAccess(): boolean {
  const isRolesViewEnabled = usePostHogFeatureFlag(POSTHOG_FEATURE_FLAGS.AD_ROLES_VIEW)
  const { canViewRolesOnAnyDomain } = usePermissions()

  return isRolesViewEnabled && canViewRolesOnAnyDomain
}
